import { useMemo } from "react";
import { useSnapshot } from "valtio";
import { siteStore } from "src/js/stores/site/store";
import { useSelectedProjectQuery } from "./useSelectedProjectQuery";
import { useProjectsList } from "react-migration/domains/projects/hooks/useProjectsList";

export function useProjectsDropdownList() {
  const { selectedProjectId } = useSnapshot(siteStore);
  const { list, ...listQueryState } = useProjectsList();
  const { selectedProject, ...selectedProjectQueryState } = useSelectedProjectQuery();
  const error = listQueryState.error || selectedProjectQueryState.error;
  const loading = listQueryState.loading || selectedProjectQueryState.loading;

  const listSansSelectedProject = useMemo(
    () => list.filter((project) => project.id !== selectedProjectId),
    [list, selectedProjectId]
  );

  return {
    selected: selectedProject,
    list: listSansSelectedProject,
    error,
    loading,
  } as const;
}
